import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject, ChangeDetectorRef } from '@angular/core';
import { ClientService } from '../services/client.service';
import { Params, ActivatedRoute,  Router } from '@angular/router';
import { Client } from '../models/client.model';
import { Subscription } from 'rxjs/Subscription';
import { StorageService } from '../services/storage.service';
import { FileDropModule, UploadFile, UploadEvent } from 'ngx-file-drop/lib/ngx-drop';
import { Auth } from '../models/auth.model';
import { ImageLibraryService } from '../shared/imagelibrary.service';
import * as copy from 'copy-to-clipboard';
import { APP_CONFIG } from '../app.config';
import { AuthService } from '../services/auth.service';

declare var $: any;
declare var swal: any;
declare var introJs: any;
declare var _bugHerd: any;

@Component({
  selector: 'app-image-library',
  templateUrl: './image-library.component.html',
  styleUrls: ['./image-library.component.css']
})
export class ImageLibraryComponent implements OnInit, OnDestroy {
  public filesDrop: UploadFile[] = [];

  loading = false;
  sid: number;
  id: number;
  gid: number;
  type = 'owned';
  subscription: Subscription;
  subscriptionStorage: Subscription;
  subscriptionSubStorage: Subscription;
  subscriptionMoveStorage: Subscription;
  subscriptionOperation: Subscription;
  subscriptionAdmin: Subscription;
  subscriptionAdminClose: Subscription;
  dragItem: any;
  dragItemElem: any;
  files = [];
  subFiles = [];
  subLevel3Files = [];
  images = [];
  selected_image = [];

  moveFiles = [];
  tempFiles = [];
  tempImages = [];

  navigationType = 'link';
  navigationDefault = 'owned';

  title = 'My Library';

  client: Client;

  path = '';
  base_path = '';
  move_base_path = '';
  folder = '';
  level = 0;

  folder_name1 = '';
  folder_name2 = '';

  current_folder = '';

  movePath = '';

  is_new_folder = false;
  is_new_image = false;
  is_on_level3 = false;

  term;

  image_dimension;

  is_builder = false;
  is_admin = false;

  have_selected = false;

  authUser: Auth;
  user = {
    ID: 21,
    client_id: 5,
    name: 'John Doe',
    photo: 'assets/img/user_photo.jpg',
    email: 'johndoe@websiteblue.com',
    mobile: '+6112345678',
    telephone: '1234 5678',
    fax: '9876 5432'
  };

  supportLink = '';

  @ViewChild('itemFile') itemFile: ElementRef;
  @ViewChild('itemFolder') itemFolder: ElementRef;
  @ViewChild('uploadItemModalClose') uploadItemModalClose: ElementRef;
  @ViewChild('newFolderModalClose') newFolderModalClose: ElementRef;
  @ViewChild('imageLibraryModalClose') imageLibraryModalClose: ElementRef;

  constructor(
    private clientService: ClientService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    private imageService: ImageLibraryService,
    private ref: ChangeDetectorRef,
    @Inject(APP_CONFIG) public appConfig) { }


  ngOnInit() {

    this.files = [];

    if (this.imageService.is_builder) {
      this.is_builder = true;
      this.authUser = this.authService.auth;
      this.client = this.authUser.client;
      this.id = this.authUser.client.ID;
      this.gid = this.authUser.client.group_id;
    }

    if (!this.imageService.is_builder && !this.imageService.is_admin) {
      this.authUser = this.authService.auth;
      this.client = this.authUser.client;
      this.id = this.authUser.client.ID;
      this.gid = this.authUser.client.group_id;
    }

    this.subscriptionAdmin = this.imageService.adminChanged.subscribe(
      (client: any) => {
        if (typeof client !== 'undefined') {
        this.is_admin = true;
        this.id = client.ID;
        this.gid = client.group_id;
      }
      }
    );


    // this.frontService.routeData.next({
    //   'route': null,
    //   default: this.navigationDefault,
    //   type: this.navigationType
    // });

    this.subscriptionStorage = this.storageService.storagesChanged.subscribe(
      (storages: any[]) => {
        if (typeof storages !== 'undefined') {

          this.loading = false;

          this.tempFiles = [];
          if (this.is_new_image === false) {
            this.files = [];
            this.files = storages;
          }
          this.images = [];
          if (this.is_new_folder === false) {
            for (let i = 0; i < storages.length; i++) {
              if (storages[i].type === 'file') {
                this.images.push(storages[i]);
              }
            }
          }

          this.ref.detectChanges();
        }
      }
    );

    this.subscriptionSubStorage = this.storageService.storagesSubChanged.subscribe(
      (storages: any[]) => {
        if (typeof storages !== 'undefined') {
          this.loading = false;
          this.ref.detectChanges();

          if (this.is_new_image === false) {
            if (this.level === 2) {
              this.subFiles = [];
              this.subFiles = storages;
            }

            if (this.level === 3) {
              this.subLevel3Files = [];
              this.subLevel3Files = storages;
            }
          }

          this.images = [];
          for (let i = 0; i < storages.length; i++) {
            if (storages[i].type === 'file') {
              this.images.push(storages[i]);
            }
          }

          this.is_new_image = false;
          this.is_new_folder = false;
        }
      }
    );

    this.subscriptionMoveStorage = this.storageService.movestoragesChanged.subscribe(
      (storages: any[]) => {
        if (typeof storages !== 'undefined') {
          this.loading = false;
          this.ref.detectChanges();

          this.moveFiles = storages;
        }
      }
    );

    this.subscriptionOperation = this.storageService.storageOperation.subscribe(
      (storages: any[]) => {
        this.storageService.httpGetStorages(this.type, this.sid);

        if (this.is_new_image) {
          // tslint:disable-next-line:max-line-length
          this.storageService.httpGetStorages(this.type, this.sid, {folder: this.folder_name1 + (this.folder_name2 !== '' ? '/' + this.folder_name2 : '')});
        }

        if (this.is_new_folder) {
          this.storageService.httpGetStorages(this.type, this.sid, {folder: (this.folder_name1 !== '' ? this.folder_name1 : '/')});
        }

        if (this.level === 2) {
          this.storageService.httpGetSubStorages(this.type, this.sid, {folder: this.folder_name1 });
        }

        this.tempImages = [];
      }
    );

    $('#displayLibrary').on({
        'dragover dragenter': function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('.dropsection-wrapper').css('display', 'block');
        },
        'drop dragstop dragend mousedown': function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('.dropsection-wrapper').css('display', 'none');
        }
    });


    $('.modal-content').on('click', function(e) {
      const container = $('.link-options');

      if (!container.is(e.target) && container.has(e.target).length === 0) {
         $('#context-menu').removeClass('context-menu--active');
      }

    });
  }

  showLink() {
    const $this = this;
    let item;
    item = this.selected_image;
    const default_extension = ['jpeg', 'jpg', 'png', 'gif', 'bmp'];
    if (item.type === 'file') {
      if ($.inArray(item.extension, default_extension) === -1) {
        swal({
          title: item.filename + ' - ' + (item.size / 1000000).toFixed(2) + 'MB',
          text: 'Dimensions:' + $this.image_dimension,
          imageUrl: '/assets/img/file-icon.png',
          imageWidth: 100,
          imageHeight: 100,
          imageAlt: 'Custom image',
          animation: true
        });
      } else {
        swal({
          title: item.filename + ' - ' + (item.size / 1000000).toFixed(2) + 'MB',
          text: 'Dimensions: ' + $this.image_dimension,
          imageUrl: this.appConfig.S3_URL + item.path,
          imageHeight: 200,
          imageAlt: 'Custom image',
          animation: true
        });
      }

    }
  }

  copyLink() {
    let item;
    item = this.selected_image;
    copy(this.appConfig.S3_URL + item.path);
  }

  getLink(item: any) {
    if (item.type === 'file') {
      return this.appConfig.S3_URL + item.path;
    }
  }

  openFolder(item: any) {
    if (item.type === 'dir') {
      this.folder_name1 = item.path.split('/')[2];
      this.loading = true;
      this.ref.detectChanges();

      if (this.folder_name1 !== item.filename) {
        this.storageService.httpGetSubStorages(this.type, this.sid, { folder: this.folder_name1 + '/' + item.filename });
      } else {
        this.storageService.httpGetSubStorages(this.type, this.sid, { folder: item.filename });
      }

      this.path = item.path;
      this.folder = item.filename;
      this.current_folder = item.path.split('/')[2];

      this.is_on_level3 = false;

      if (item.path.split('/')[2] !== undefined) {
        this.folder_name2 = '';
        this.level = 2;
      }

      if (item.path.split('/')[3] !== undefined) {
        this.level = 3;
        this.folder_name2 = item.filename;
        this.is_on_level3 = true;
      }

    }
  }

  openRoot() {
    this.loading = true;
    this.ref.detectChanges();

    this.path = this.base_path;
    this.folder = '';
    this.folder_name1 = '';
    this.folder_name2 = '';
    this.subFiles = [];
    this.subLevel3Files = [];
    this.files = [];
    this.storageService.httpGetStorages(this.type, this.sid, this.path);
  }

  onUpload() {

    this.loading = true;
    this.ref.detectChanges();

    this.is_new_image = true;

    const fileSingle = this.itemFile.nativeElement;

    const values = [];

    for (let i = 0; i < fileSingle.files.length; i++) {
      this.tempImages.push(fileSingle.files[i]);
    }

    values['file'] = this.tempImages;
    values['type'] = 'file';
    values['path'] = this.path;

    this.storageService.httpPostStorage(values);

    setTimeout(
      () => {
        $('#uploadItem').modal('hide');
        this.itemFile.nativeElement.value = '';
      }, 100
    );

  }
  checkFileSize(event) {
    if (event.target.files[0].size > 10000000) {
      swal(
        'File is too big',
        'Maximum file size is 10 MB',
        'error'
      );
    }

    const temp_files_length = event.target.files.length;

    for (let i = 0; i < temp_files_length; i++) {
      this.tempFiles.push(event.target.files[i]);
    }
  }

  onSubmit() {
    const values = [];

    if (this.itemFolder.nativeElement.value.trim() === '') {
      swal(
        'Error',
        'Invalid Folder Name',
        'error'
      ).catch(swal.noop);

    }

    if (this.itemFolder.nativeElement.value.trim() !== '') {
      this.loading = true;
      this.ref.detectChanges();

      const _folder_name = this.itemFolder.nativeElement.value;

      values['name'] = _folder_name.split(' ').join('');
      values['type'] = 'dir';
      values['path'] = this.path;

      this.is_new_folder = true;

      this.storageService.httpPostStorage(values);

      setTimeout(
        () => {
          $('#newFolder').modal('hide');
          this.itemFolder.nativeElement.value = '';
        }, 200
      );
    }
  }

  onInsert() {
    let item;
    item = this.selected_image;
    this.have_selected = false;

    this.imageService.onInsert(item);
    this.imageLibraryModalClose.nativeElement.click();
  }

  onDelete() {
    let item;
    item = this.selected_image;
    const $this = this;

    const path = String(item.path).split('/');

    // tslint:disable-next-line:radix
    if ( !this.authUser.is_master && this.authUser.client.ID !== parseInt(path[1]) ) {
      swal(
        'Error deleting',
        'You don\'t have enough permission to delete this ' + item.type,
        'error'
      );
      return false;
    }

    swal({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete'
      }).then(function () {
        swal(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );

        const values = [];
        $this.loading = true;
        $this.ref.detectChanges();

        if (item.path) {
          values['type'] = item.type;
          values['path'] = item.path;

          $this.storageService.httpDeleteStorage(values);
        }
      });

  }

  allowDrop(event) {
    event.preventDefault();
  }

  drop(event, item: any) {
    const $this = this;
    const elmDrag = this.dragItemElem;
    setTimeout(function(){
      elmDrag.parent('a').hide();
    });

    const values = [];
    $this.loading = true;
    $this.ref.detectChanges();

    if (this.dragItem.path && item.path) {
      values['type'] = this.dragItem.type;
      values['path'] = this.dragItem.path;
      values['move_to_path'] = item.path + '/' + this.dragItem.basename;
      $this.storageService.httpMoveStorage(values);
    }
  }

  onDrag(event, item: any) {
    this.dragItemElem = $(event.target);
    this.dragItem = item;
  }

  startTour() {
    introJs().start();
  }

  onFeedback() {
    swal({
      title: 'We would love to hear from you about the new MyDesign',
      imageUrl: 'https://mydesign3.wbclients.com/mydesign/assets/images/message-square.svg',
      imageWidth: 300,
      imageHeight: 100,
      showConfirmButton: false,
      html: '<p>Please choose to provide either Feedback or log a Support Ticket</p>' +
      // tslint:disable-next-line:max-line-length
      '<a class="btn btn-success btn-bh-feedback">Send Feedback</a> &nbsp; <a href="' + this.supportLink + '" target="_blank" class="btn btn-info btn-support-log">Log Support Ticket</a>'
      } );

      $('.btn-bh-feedback').click(function() {
        swal.close();
        _bugHerd.win.bugherd.applicationView.anonymousbar.toggleOptions();
      });

  }


  displayOptions(event, file) {
    const $this = this;
    const img = new Image();
    img.onload = function() {
      $this.image_dimension = (img.width + ' x ' + img.height).toString();
    };

    img.src = this.appConfig.S3_URL + file.path;
    this.selected_image = file;

    if (event.pageY > ($(document).height() - 100)) {
      $('#context-menu').css({
        'left': event.pageX - 150,
        'top': event.pageY - 150
      });
    } else if (event.pageX > ($(document).width() - 100)) {
      $('#context-menu').css({
        'left': event.pageX - 150,
        'top': event.pageY
      });
    } else {
      $('#context-menu').css({
        'left': event.pageX,
        'top': event.pageY
      });
    }

    $('#context-menu').addClass('context-menu--active');
    return false;
  }

  public dropped(event: UploadEvent) {
    this.loading = true;
    this.ref.detectChanges();
    const values = [];
    this.is_new_image = true;

    this.filesDrop = event.files;
    for (const file of event.files) {

      file.fileEntry.file(info => {
        this.tempImages.push(info);

      });
    }

    values['file'] = this.tempImages;
    values['type'] = 'file';
    values['path'] = this.path;

    setTimeout(
      () => {
        this.storageService.httpPostStorage(values);
      }, 1000
    );

    $('.dropsection-wrapper').css('display', 'none');
  }


  openOwnLibrary(client_id = 0) {
    if (this.imageService.is_builder) {
      this.is_builder = true;
      this.authUser = this.authService.auth;
      this.client = this.authUser.client;
      this.id = this.authUser.client.ID;
      this.gid = this.authUser.client.group_id;
    }

    if ( client_id !== 0 ) {
      this.sid = client_id;
    }

    this.loading = true;
    this.have_selected = false;
    this.sid = this.id;
    this.path = 'clients/' + this.id;
    this.type = 'owned';

    this.base_path = this.path;

    if (this.id) {
      this.storageService.httpGetStorages(this.type, this.sid);
    }

    this.imageService.onAdminClose();
    this.ref.detectChanges();
  }

  openSharedLibrary(group_id = 0) {
    if (this.imageService.is_builder) {
      this.is_builder = true;
      this.authUser = this.authService.auth;
      this.client = this.authUser.client;
      this.id = this.authUser.client.ID;
      this.gid = this.authUser.client.group_id;
    }

    if ( group_id !== 0 ) {
      this.gid = group_id;
    }

    this.loading = true;
    this.ref.detectChanges();

    this.sid = this.gid;
    this.have_selected = false;
    this.path = 'groups/'  + this.gid;
    this.type = 'shared';

    this.base_path = this.path;

    if (this.gid) {
      this.storageService.httpGetStorages(this.type, this.sid);
    }

    this.imageService.onAdminClose();
  }

  openAdmin() {
    this.is_admin = true;
    this.path = 'admin/' + this.id;
    this.type = 'admin';

    this.base_path = this.path;

    this.sid = this.id;

    if (this.id) {
      this.storageService.httpGetStorages(this.type, this.sid);
    }

    this.imageService.onAdminClose();
  }

  openMoveFile() {
    this.loading = true;
    this.ref.detectChanges();

    this.movePath = this.base_path;

    this.storageService.httpGetMoveStorages(this.type, this.sid);
  }

  openMoveFolder(folder) {
    this.loading = true;
    this.ref.detectChanges();

    this.movePath = folder.path;

    this.storageService.httpGetMoveStorages(this.type, this.sid, { folder: folder.basename });
  }

  setBreadcrumb(path) {
    if (path.split('/')[2] !== undefined && path.split('/')[3] === undefined) {
      return ' > ' + path.split('/')[2];
    }

    if (path.split('/')[3] !== undefined) {
      return ' > ' + path.split('/')[2] + ' > ' + path.split('/')[3];
    }

    return '';
  }

  backMoveFolder() {
    this.loading = true;
    this.ref.detectChanges();

    this.movePath = this.base_path;

    this.storageService.httpGetMoveStorages(this.type, this.sid);
  }

  moveFile() {
    this.loading = true;
    this.ref.detectChanges();

    const values = [];

    let item;
    item = this.selected_image;

    values['type'] = item.type;
    values['path'] = item.path;
    values['move_to_path'] = this.movePath + '/' + item.basename;

    this.storageService.httpMoveStorage(values);
    $('#moveFile').modal('hide');
  }

  truncateName(str) {
    if (str.length < 20) {
      return str;
    } else {
      return str.substring(0, 20) + '...';
    }
  }

  onImageClick(event, image) {
    if (this.is_builder === true) {
      this.have_selected = true;
      this.selected_image = image;
      $('.builder_selected').css({'background-color': '', 'border-radius': '0'});
      $('.builder_selected').removeClass('builder_selected');
      $(event.target).closest('.photo-wrapper').addClass('builder_selected');
      $(event.target).closest('.photo-wrapper').css({'background-color': '#36ab7a', 'border-radius': '5px'});
    }

    this.ref.detectChanges();
  }

  onDeleteFolder(file) {
    const $this = this;

    swal({
      title: 'Are you sure?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete'
    }).then(function () {
      swal(
        'Deleted!',
        'Your file has been deleted.',
        'success'
      );

      $this.path = $this.base_path;
      $this.folder = '';
      $this.folder_name1 = '';
      $this.folder_name2 = '';
      $this.subFiles = [];
      $this.subLevel3Files = [];
      $this.files = [];
      const values = [];
      $this.loading = true;
      $this.ref.detectChanges();

        values['type'] = file.type;
        values['path'] = file.path;

        $this.storageService.httpDeleteStorage(values);
    });


    const e = window.event;
    e.stopPropagation();
  }

  closeModal(id) {
    $('#' + id).modal('hide');
  }

  closeLibrary() {
    this.imageService.onCloseLibrary.next(true);
  }

  ngOnDestroy() {
    this.subscriptionStorage.unsubscribe();
    this.subscriptionSubStorage.unsubscribe();
    this.subscriptionMoveStorage.unsubscribe();
    this.subscriptionOperation.unsubscribe();
    this.subscriptionAdmin.unsubscribe();
  }



}



// WEBPACK FOOTER //
// ./src/app/image-library/image-library.component.ts